interface SapLogoProps {
  className?: string;
  size?: number;
}

export const SapLogo = ({ className, size = 40 }: SapLogoProps) => {
  const height = size;
  const width = size * (49 / 24);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 49 24"
      fill="none"
      className={className}
      style={{ height, width }}
    >
      <path fill="url(#sap-gradient)" fillRule="evenodd" d="M0 24h24.458L48.393 0H0v24Z" clipRule="evenodd" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m28.72 4.512-4.765-.003v11.355L19.795 4.51h-4.127l-3.553 9.496c-.378-2.394-2.849-3.22-4.793-3.84C6.04 9.75 4.677 9.142 4.69 8.471c.01-.552.73-1.064 2.156-.987.959.051 1.804.129 3.487.942l1.655-2.889C10.452 4.755 8.33 4.26 6.59 4.258h-.01c-2.027 0-3.717.658-4.765 1.744a4.033 4.033 0 0 0-1.14 2.786c-.026 1.465.51 2.505 1.636 3.333.951.7 2.168 1.153 3.24 1.486 1.322.41 2.401.768 2.389 1.53-.01.277-.115.535-.314.745-.329.34-.836.469-1.535.482-1.35.029-2.35-.183-3.944-1.128l-1.471 2.93a10.98 10.98 0 0 0 5.392 1.438l.247-.002c1.672-.03 3.022-.508 4.1-1.378.061-.05.117-.1.174-.15l-.478 1.279h4.327l.727-2.215a7.88 7.88 0 0 0 2.543.405 7.99 7.99 0 0 0 2.483-.383l.7 2.193h7.057v-4.585h1.54c3.72 0 5.92-1.9 5.92-5.083 0-3.545-2.138-5.172-6.69-5.172ZM17.71 14.23a4.332 4.332 0 0 1-1.527-.268l1.51-4.776h.029l1.483 4.79a4.48 4.48 0 0 1-1.495.254Zm11.289-2.744h-1.05V7.636H29c1.4 0 2.515.466 2.515 1.899 0 1.482-1.116 1.95-2.515 1.95Z"
        clipRule="evenodd"
      />
      <defs>
        <linearGradient id="sap-gradient" x1="24.197" x2="24.197" y1="0" y2="24" gradientUnits="userSpaceOnUse">
          <stop stopColor="#00B1EB" />
          <stop offset=".212" stopColor="#009AD9" />
          <stop offset=".519" stopColor="#007FC4" />
          <stop offset=".792" stopColor="#006EB8" />
          <stop offset="1" stopColor="#0069B4" />
        </linearGradient>
      </defs>
    </svg>
  );
};
